import { Scissors, Sparkles, UserRound, Wand2, Wind, Baby, Paintbrush } from "lucide-react";
import { Reveal, Kicker } from "./Reveal";
import { SERVICES } from "../../data/site";

const ICONS = { Scissors, Sparkles, UserRound, Wand2, Wind, Baby, Paintbrush };

export const Services = () => {
    return (
        <section
            id="servicii"
            data-testid="services-section"
            className="relative bg-[#f5f4f2] py-24 text-neutral-900 md:py-36"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <div className="max-w-2xl">
                    <Reveal>
                        <Kicker dark>Servicii</Kicker>
                    </Reveal>
                    <Reveal delay={0.05}>
                        <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight sm:text-5xl lg:text-6xl">
                            Servicii pentru <span className="text-neutral-400">fiecare stil</span>
                        </h2>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <p className="mt-6 font-body text-lg text-neutral-600">
                            De la o tunsoare clasică la un skin fade impecabil — fiecare
                            serviciu este executat cu precizie și pasiune.
                        </p>
                    </Reveal>
                </div>

                <div className="mt-16 grid grid-cols-1 gap-px overflow-hidden rounded-2xl border border-neutral-200 bg-neutral-200 md:grid-cols-2 lg:grid-cols-3">
                    {SERVICES.map((s, i) => {
                        const Icon = ICONS[s.icon];
                        return (
                            <Reveal
                                key={s.title}
                                delay={(i % 3) * 0.08}
                                className="group relative bg-[#f5f4f2] p-9 transition-colors duration-500 hover:bg-neutral-900"
                                data-testid={`service-card-${i}`}
                            >
                                <div className="flex h-full flex-col">
                                    <div className="mb-8 flex items-center justify-between">
                                        <Icon
                                            size={34}
                                            strokeWidth={1.25}
                                            className="text-neutral-900 transition-colors duration-500 group-hover:text-gold"
                                        />
                                        <span className="font-display text-sm text-neutral-300 transition-colors duration-500 group-hover:text-neutral-600">
                                            0{i + 1}
                                        </span>
                                    </div>
                                    <h3 className="font-display text-2xl font-medium tracking-tight text-neutral-900 transition-colors duration-500 group-hover:text-white">
                                        {s.title}
                                    </h3>
                                    <p className="mt-3 font-body text-sm leading-relaxed text-neutral-600 transition-colors duration-500 group-hover:text-neutral-300">
                                        {s.desc}
                                    </p>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};
